import React, { useState, useEffect} from 'react'
import axios from '../../api/api'
import { useParams } from 'react-router-dom'

const CustomerDetails = () => {
  const { id } = useParams()

  const [viewCustomer, setViewCustomer] = useState([])

  // getting customer by id
  useEffect(() => {
    const getCustomer = async () => {
      try {
        const response = await axios.get(`/customer/${id}/details`)
        setViewCustomer(response.data)
      } catch (error) {
        console.log(error)
      }
    }
    getCustomer()
  },[id])

  return (
    <div>
      <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
        <div className='bg-white p-4 rounded-lg'>
          <h4>Customer Details</h4>
          <hr /> 
          <div className='my-2 space-y-4'>
            <div className="flex items-center justify-between">
              <h5>Phone Number:</h5>
              <span>{viewCustomer.msisdn}</span>
            </div>
            <div className="flex items-center justify-between">
              <h5>Date created:</h5>
              <span>{viewCustomer.date_created ? new Date(viewCustomer.date_created).toLocaleString("en-CA", { hour12: false }) : ''}</span>
            </div>
            <div className="flex items-center justify-between">
              <h5>Status:</h5>
              <span>{viewCustomer.status}</span>
            </div>
            <div className="flex items-center justify-between">
              <h5>User Type:</h5>
              {viewCustomer.user_type === 1 ? (
                <span>Customer</span>
              ) : viewCustomer.user_type === 2 ? (
                <span>Agent</span>
              ) : (
                <span>Dealer</span>
              )}
            </div>
          </div>
        </div>

        <div className='bg-white p-4 rounded-lg'>
          <h4>Account Details</h4>
          <hr /> 
          <div className='my-2 space-y-4'>
            <div className="flex items-center justify-between">
              <h5>Commision:</h5>
              <span>{viewCustomer.commission}</span>
            </div>
            <div className="flex items-center justify-between">
              <h5>Net Value:</h5>
              <span>{viewCustomer.net_value}</span>
            </div>
            <div className="flex items-center justify-between">
              <h5>Unit Consumed:</h5>
              <span>{viewCustomer.unit_consumed}</span>
            </div>
            <div className="flex items-center justify-between">
              <h5>Points:</h5>
              <span>{viewCustomer.points}</span>
            </div>
          </div>
        </div>

        <div className='bg-white p-4 rounded-lg'>
          <h4>Dealer Information</h4>
          <hr /> 
          <div className='my-2 space-y-4'>
            <div className="flex items-center justify-between">
              <h5>Phone Number:</h5>
              <span>{viewCustomer.msisdn}</span>
            </div>
            <div className="flex items-center justify-between">
              <h5>Date created:</h5>
              <span>{viewCustomer.date_created ? new Date(viewCustomer.date_created).toLocaleString("en-CA", { hour12: false }) : ''}</span>
            </div>
            <div className="flex items-center justify-between">
              <h5>Status:</h5>
              <span>{viewCustomer.status}</span>
            </div>
            <div className="flex items-center justify-between">
              <h5>User Type:</h5>
              {viewCustomer.user_type === 1 ? (
                <span>Customer</span>
              ) : viewCustomer.user_type === 2 ? (
                <span>Agent</span>
              ) : (
                <span>Dealer</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomerDetails
